import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';
import { research } from './data.js';

/**
 * @param {string} id
 */
export default function gridResearch(id) {
    if (!document.getElementById(id)) return;

    Grid.grid(id, {
        dataTable: {
            columns: {
                "Miasto": research.map(e => e.city),
                "Liczba nieprawidłowo<br>zaparkowanych pojazdów": research.map(e => `Pojazdów w obszarze: ${e.count.toLocaleString('pl-PL')}<br><i>(Szacunek dla całego miasta: ${Math.round(e.count / (e.residentPercent / 100)).toLocaleString('pl-PL')})</i>`),
                "Obszar badania": research.map(e => `${e.area}<br><i>(Obszar zamieszkany przez około ${e.residentPercent}% mieszkańców miasta)</i>`),
                "Źródło": research.map(e => e.source)
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [{
            id: "Miasto",
            cells: {
                className: 'bold'
            },
            width: 100
        }, {
            id: "Liczba nieprawidłowo<br>zaparkowanych pojazdów",
            cells: {
                format: '{value}'
            },
        }, {
            id: "Obszar badania"
        }, {
            id: "Źródło"
        }]
    });
}
